export default "__VITE_ASSET__DWrHcufW__"